var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-default",attrs:{"href":_vm.editStrategyUrl}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("\n  Edit\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }